import { StationsServiceInterface } from "interfaces/stations-service"
import { BaseMmsMockService } from "services/mms/mock/entities-services/BaseMockService"
import { CommunicationService } from "services/mms/mock/CommunicationService"

export class MockStationsService
    extends BaseMmsMockService
    implements StationsServiceInterface
{
    constructor(communicationService: CommunicationService) {
        super(communicationService)
    }

    useGetStations = (): FetchApiProps => {
        const datas = {
            mockStatus: 200,
            delay: 500,
            controllerFn: () => {
                return {data: this.communicationService.stations.map((d) => ({ ...d }))}
            },
        }

        return this.get(datas)
    }

    useGetStation: (station_id: string) => FetchApiProps = (station_id) => {
        const datas = {
            mockStatus: 200,
            delay: 500,
            controllerFn: () => {
                return {data: this.communicationService.stations.find((d) => d.id === station_id) || null}
            },
        }

        return this.get(datas)
    }
}
